import {API_URLS} from '@px/const/urls';
import {http} from '@px/helper/http';

export const collectionApi = {
  cnt(id) {
    return http.post(API_URLS.CNT_COLLECTION, {params: {id}});
  },
};
